import { render } from "./EditOrderIds.vue?vue&type=template&id=263b87e7"
import script from "./EditOrderIds.vue?vue&type=script&lang=js"
export * from "./EditOrderIds.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__